(() => {
  const WISHLIST_KEY = 'embe:wishlist:v1';

  function safeParse(json, fallback) {
    try {
      return JSON.parse(json);
    } catch {
      return fallback;
    }
  }

  function normalizeHandles(list) {
    const out = [];
    const seen = new Set();
    if (!Array.isArray(list)) return out;
    for (const item of list) {
      let h = '';
      if (typeof item === 'string') h = item.trim();
      else if (item && typeof item === 'object' && typeof item.handle === 'string') h = item.handle.trim();
      if (!h || seen.has(h)) continue;
      seen.add(h);
      out.push(h);
    }
    return out;
  }

  function readRawWishlistArray() {
    const raw = window.localStorage.getItem(WISHLIST_KEY);
    const arr = safeParse(raw, []);
    return Array.isArray(arr) ? arr : [];
  }

  function getWishlist() {
    return normalizeHandles(readRawWishlistArray());
  }

  /** Rewrite storage if legacy format (objects, duplicates, whitespace). */
  function fixWishlistStorageShape() {
    const rawArr = readRawWishlistArray();
    const next = normalizeHandles(rawArr);
    if (JSON.stringify(rawArr) !== JSON.stringify(next)) {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(next));
    }
  }

  function setWishlist(handles) {
    const clean = normalizeHandles(handles);
    window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(clean));
    window.dispatchEvent(new CustomEvent('embe:wishlist:changed', { detail: { handles: clean } }));
  }

  function removeHandle(handle) {
    const list = getWishlist().filter((h) => h !== handle);
    setWishlist(list);
  }

  function isWishlisted(handle) {
    const h = String(handle || '').trim();
    return h ? getWishlist().includes(h) : false;
  }

  function refreshWishlistButtons(root = document) {
    root.querySelectorAll('[data-card-action="wishlist"][data-product-handle]').forEach((btn) => {
      const handle = (btn.getAttribute('data-product-handle') || '').trim();
      const active = handle && isWishlisted(handle);
      btn.classList.toggle('is-active', Boolean(active));
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  /** Header bubble on every page; hidden via CSS when empty (:empty). */
  function updateWishlistCountBubble() {
    fixWishlistStorageShape();
    const count = getWishlist().length;
    const label = count > 0 ? String(count) : '';
    document.querySelectorAll('[data-wishlist-count-bubble]').forEach((el) => {
      el.textContent = label;
    });
  }

  async function renderWishlist(root) {
    const grid = root.querySelector('[data-wishlist-grid]');
    const empty = root.querySelector('[data-wishlist-empty]');
    const errEl = root.querySelector('[data-wishlist-error]');
    const loading = root.querySelector('[data-wishlist-loading]');
    const productNodes = {};
    if (!grid) return;

    fixWishlistStorageShape();
    const handles = getWishlist();

    if (errEl) errEl.hidden = true;

    updateWishlistCountBubble();

    if (!handles.length) {
      grid.innerHTML = '';
      if (loading) loading.remove();
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    const failures = [];
    const promises = handles.map(async (hdl) => {
      const url = formatUrl('products', hdl, 'view=wishlist-item');
      const prodHTML = await fetchCache(url);
      const item = document.createElement('li');
      item.classList.add('grid__item');
      item.innerHTML = prodHTML;

      if (item.querySelector('.product-card-wrapper')) {
        productNodes[hdl] = item;
      } else {
        failures.push(hdl);
      }
    })

    await Promise.all(promises);

    if (failures.length) {
      console.warn('[wishlist] could not load some products', failures);
    }

    grid.innerHTML = '';
    handles.forEach((hdl) => {
      const prod = productNodes[hdl];
      if (prod) {
        grid.appendChild(prod);
      }
    });

    refreshWishlistButtons(document);
    
    if (loading) loading.remove();
  }

  function onWishlistChanged() {
    updateWishlistCountBubble();
    refreshWishlistButtons(document);
    const root = document.querySelector('[data-wishlist-page]');
    if (root) renderWishlist(root);
  }

  function init() {
    updateWishlistCountBubble();
    refreshWishlistButtons(document);

    const root = document.querySelector('[data-wishlist-page]');
    if (root) renderWishlist(root);

    window.addEventListener('embe:wishlist:changed', onWishlistChanged);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    updateWishlistCountBubble();
    refreshWishlistButtons(document);
    const root = document.querySelector('[data-wishlist-page]');
    if (root) renderWishlist(root);
  });
})();
